"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.slideControlsClasses = exports.StateSlideControls = void 0;
// istanbul ignore file: doesn't hold any logic
const SlideControls_1 = __importDefault(require("./SlideControls"));
var SlideControls_2 = require("./SlideControls");
Object.defineProperty(exports, "StateSlideControls", { enumerable: true, get: function () { return SlideControls_2.StateSlideControls; } });
var styles_1 = require("./styles");
Object.defineProperty(exports, "slideControlsClasses", { enumerable: true, get: function () { return styles_1.classes; } });
exports.default = SlideControls_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc2xpZGUtY29udHJvbHMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsK0NBQStDO0FBQy9DLG9FQUE0QztBQUc1QyxpREFBcUQ7QUFBNUMsbUhBQUEsa0JBQWtCLE9BQUE7QUFFM0IsbUNBQTJEO0FBQWxELDhHQUFBLE9BQU8sT0FBd0I7QUFFeEMsa0JBQWUsdUJBQWEsQ0FBQyJ9